/* ============================================================
   RIPNDIP Y2K RETRO MODE — JavaScript
   Toggle, sparkle cursor, taskbar clock, start menu,
   Nerm Invaders game, product tour webring, VIP club
   ============================================================ */

(function () {
  'use strict';

  var STORAGE_KEY = 'ripndip_y2k_mode';
  var sparkles = ['\u2728', '\u2B50', '\u2734\uFE0F', '\u2604\uFE0F', '\u26A1', '\uD83D\uDCAB', '\u2742', '\u2600\uFE0F'];
  var sparkleInterval = null;
  var clockInterval = null;
  var fallingStarInterval = null;
  var fallingEmoji = ['\u2B50', '\u2728', '\u{1F31F}', '\u2734\uFE0F', '\u{1F496}', '\u{1F49C}', '\u2764\uFE0F'];
  var startMenuOpen = false;

  /* ---- HELPER: Add HTML element ---- */
  function createEl(tag, attrs, html) {
    var el = document.createElement(tag);
    if (attrs) {
      for (var k in attrs) {
        if (attrs.hasOwnProperty(k)) el.setAttribute(k, attrs[k]);
      }
    }
    if (html) el.innerHTML = html;
    return el;
  }

  /* ---- TOGGLE ---- */
  function isY2KActive() {
    try { return localStorage.getItem(STORAGE_KEY) === 'true'; } catch (e) { return false; }
  }

  function setY2K(active) {
    try { localStorage.setItem(STORAGE_KEY, active ? 'true' : 'false'); } catch (e) { /* noop */ }
  }

  function enableY2K() {
    document.body.classList.add('y2k-mode');
    setY2K(true);
    injectY2KElements();
    startSparkles();
    startClock();
    startFallingStars();
    updateToggleLabels(true);
  }

  function disableY2K() {
    document.body.classList.remove('y2k-mode');
    setY2K(false);
    removeY2KElements();
    stopSparkles();
    stopClock();
    stopFallingStars();
    closeStartMenu();
    closeNermInvaders();
    updateToggleLabels(false);
  }

  function toggleY2K(e) {
    if (e) e.preventDefault();
    if (isY2KActive()) { disableY2K(); } else { enableY2K(); }
  }

  function updateToggleLabels(active) {
    var links = document.querySelectorAll('.y2k-toggle-link');
    for (var i = 0; i < links.length; i++) {
      links[i].textContent = active ? '\u{1F4BE} Exit Retro Mode' : '\u{1F4BE} Enter Y2K Mode';
    }
  }

  /* ---- RANDOM PRODUCT (for webring) ---- */
  function goToRandomProduct(e) {
    if (e) e.preventDefault();
    fetch('/collections/all/products.json?limit=250')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.products && data.products.length) {
          var p = data.products[Math.floor(Math.random() * data.products.length)];
          window.location.href = '/products/' + p.handle;
        }
      })
      .catch(function () {
        window.location.href = '/collections/all';
      });
  }

  /* ---- FALLING STARS ---- */
  function startFallingStars() {
    if (fallingStarInterval) return;
    fallingStarInterval = setInterval(function () {
      if (!document.body.classList.contains('y2k-mode')) return;
      var star = createEl('span', { class: 'y2k-falling-star' });
      star.textContent = fallingEmoji[Math.floor(Math.random() * fallingEmoji.length)];
      star.style.left = Math.random() * 100 + 'vw';
      star.style.fontSize = (10 + Math.random() * 14) + 'px';
      star.style.animationDuration = (3 + Math.random() * 5) + 's';
      document.body.appendChild(star);
      var dur = parseFloat(star.style.animationDuration) * 1000;
      setTimeout(function () { if (star.parentNode) star.parentNode.removeChild(star); }, dur);
    }, 600);
  }

  function stopFallingStars() {
    if (fallingStarInterval) { clearInterval(fallingStarInterval); fallingStarInterval = null; }
    var stars = document.querySelectorAll('.y2k-falling-star');
    for (var i = 0; i < stars.length; i++) { if (stars[i].parentNode) stars[i].parentNode.removeChild(stars[i]); }
  }

  /* ============================================================
     START MENU
     ============================================================ */
  function toggleStartMenu() {
    if (startMenuOpen) { closeStartMenu(); } else { openStartMenu(); }
  }

  function openStartMenu() {
    if (document.getElementById('y2k-start-menu')) return;
    startMenuOpen = true;
    var menu = createEl('div', { id: 'y2k-start-menu', class: 'y2k-start-menu' });
    menu.innerHTML =
      '<div class="y2k-sm-sidebar">' +
        '<span class="y2k-sm-sidebar-text">RIPNDIP<br>Y2K</span>' +
      '</div>' +
      '<div class="y2k-sm-items">' +
        '<div class="y2k-sm-item" id="y2k-sm-nerm">\u{1F47E} Nerm Invaders</div>' +
        '<div class="y2k-sm-item" id="y2k-sm-vip">\u{1F451} Join VIP Club</div>' +
        '<div class="y2k-sm-divider"></div>' +
        '<div class="y2k-sm-item" id="y2k-sm-random">\u{1F3B2} Random Product</div>' +
        '<div class="y2k-sm-item" id="y2k-sm-shop">\u{1F6CD}\uFE0F Shop All</div>' +
        '<div class="y2k-sm-divider"></div>' +
        '<div class="y2k-sm-item" id="y2k-sm-exit">\u{1F6AA} Exit Y2K Mode</div>' +
      '</div>';
    document.body.appendChild(menu);

    // Bind menu items
    document.getElementById('y2k-sm-nerm').addEventListener('click', function () { closeStartMenu(); openNermInvaders(); });
    document.getElementById('y2k-sm-vip').addEventListener('click', function () { closeStartMenu(); openVIPClub(); });
    document.getElementById('y2k-sm-random').addEventListener('click', function () { closeStartMenu(); goToRandomProduct(); });
    document.getElementById('y2k-sm-shop').addEventListener('click', function () { closeStartMenu(); window.location.href = '/collections/all'; });
    document.getElementById('y2k-sm-exit').addEventListener('click', function () { closeStartMenu(); disableY2K(); });

    // Close on outside click
    setTimeout(function () {
      document.addEventListener('click', outsideStartMenuClick);
    }, 50);
  }

  function closeStartMenu() {
    startMenuOpen = false;
    var el = document.getElementById('y2k-start-menu');
    if (el) el.parentNode.removeChild(el);
    document.removeEventListener('click', outsideStartMenuClick);
  }

  function outsideStartMenuClick(e) {
    var menu = document.getElementById('y2k-start-menu');
    var btn = document.getElementById('y2k-start-btn');
    if (menu && !menu.contains(e.target) && btn && !btn.contains(e.target)) {
      closeStartMenu();
    }
  }

  /* ============================================================
     VIP CLUB DIALOG
     ============================================================ */
  function openVIPClub() {
    if (document.getElementById('y2k-vip-dialog')) return;
    var dialog = createEl('div', { id: 'y2k-vip-dialog', class: 'y2k-dialog-overlay' });
    dialog.innerHTML =
      '<div class="y2k-dialog">' +
        '<div class="y2k-dialog-titlebar">' +
          '<span>\u{1F451} RIPNDIP VIP Club \u{1F451}</span>' +
          '<span class="y2k-dialog-close" id="y2k-vip-close">X</span>' +
        '</div>' +
        '<div class="y2k-dialog-body">' +
          '<div style="text-align:center;padding:15px;">' +
            '<div style="font-size:20px;font-weight:bold;color:#FF1493!important;margin-bottom:10px;font-family:Comic Sans MS,cursive!important;">' +
              '\u{1F31F} \u{1F451} VIP CLUB \u{1F451} \u{1F31F}' +
            '</div>' +
            '<div style="font-size:13px;margin-bottom:12px;font-family:Comic Sans MS,cursive!important;color:#000!important;">' +
              'Join the exclusive RIPNDIP VIP Club 4 early access 2 drops, secret sales & members-only merch!!' +
            '</div>' +
            '<div style="font-size:11px;color:#808080!important;margin-bottom:15px;">' +
              '\u{1F48E} Early access to new drops<br>' +
              '\u{1F525} VIP-only discounts<br>' +
              '\u{1F381} Birthday surprises<br>' +
              '\u{1F47E} Secret Nerm content' +
            '</div>' +
            '<div style="font-size:12px;margin-bottom:8px;color:#000!important;">' +
              'Enter ur email 2 join:' +
            '</div>' +
            '<div style="display:flex;gap:4px;justify-content:center;margin-bottom:10px;">' +
              '<input type="email" id="y2k-vip-email" placeholder="xXx_ur_email@aol.com_xXx" ' +
                'style="font-family:MS Sans Serif,Tahoma!important;font-size:11px;border:2px inset #808080;padding:4px 8px;width:200px;background:#fff;color:#000;">' +
              '<button id="y2k-vip-submit" style="font-family:MS Sans Serif,Tahoma!important;font-size:11px;background:#C0C0C0;border:2px outset #fff;border-right-color:#808080;border-bottom-color:#808080;padding:4px 12px;cursor:pointer;font-weight:bold;color:#000;">JOIN!</button>' +
            '</div>' +
            '<div id="y2k-vip-msg" style="font-size:11px;color:#008000!important;display:none;">' +
              '\u2714 OMG ur in!! Check ur inbox bb \u{1F48C}' +
            '</div>' +
            '<div style="font-size:9px;color:#C0C0C0!important;margin-top:8px;">' +
              'P.S. We promise not 2 spam u... maybe lol \u{1F608}' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(dialog);

    document.getElementById('y2k-vip-close').addEventListener('click', function () {
      var el = document.getElementById('y2k-vip-dialog');
      if (el) el.parentNode.removeChild(el);
    });

    document.getElementById('y2k-vip-submit').addEventListener('click', function () {
      var email = document.getElementById('y2k-vip-email').value;
      if (email && email.indexOf('@') > -1) {
        document.getElementById('y2k-vip-msg').style.display = 'block';
        document.getElementById('y2k-vip-email').value = '';
      }
    });

    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) {
        dialog.parentNode.removeChild(dialog);
      }
    });
  }

  /* ============================================================
     NERM INVADERS — Space Invaders mini-game
     ============================================================ */
  var nermGame = null;

  function openNermInvaders() {
    if (document.getElementById('y2k-nerm-dialog')) return;
    var dialog = createEl('div', { id: 'y2k-nerm-dialog', class: 'y2k-dialog-overlay' });
    dialog.innerHTML =
      '<div class="y2k-dialog y2k-dialog--game">' +
        '<div class="y2k-dialog-titlebar">' +
          '<span>\u{1F47E} Nerm Invaders v1.0 \u{1F47E}</span>' +
          '<span class="y2k-dialog-close" id="y2k-nerm-close">X</span>' +
        '</div>' +
        '<div class="y2k-dialog-body" style="padding:0!important;background:#000!important;">' +
          '<canvas id="y2k-nerm-canvas" width="400" height="350" style="display:block;image-rendering:pixelated;"></canvas>' +
          '<div id="y2k-nerm-hud" style="background:#000;color:#0f0!important;font-family:Courier New,monospace!important;font-size:11px;padding:4px 8px;display:flex;justify-content:space-between;">' +
            '<span id="y2k-nerm-score">Score: 0</span>' +
            '<span id="y2k-nerm-lives">Lives: 3</span>' +
          '</div>' +
          '<div style="background:#111;color:#0f0!important;font-family:Courier New,monospace!important;font-size:9px;padding:3px 8px;text-align:center;">' +
            '\u2190 \u2192 = Move  |  SPACE = Shoot  |  Click canvas to start' +
          '</div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(dialog);

    document.getElementById('y2k-nerm-close').addEventListener('click', closeNermInvaders);
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) closeNermInvaders();
    });

    initNermGame();
  }

  function closeNermInvaders() {
    if (nermGame) { nermGame.running = false; nermGame = null; }
    var el = document.getElementById('y2k-nerm-dialog');
    if (el) el.parentNode.removeChild(el);
  }

  function initNermGame() {
    var canvas = document.getElementById('y2k-nerm-canvas');
    if (!canvas) return;
    var ctx = canvas.getContext('2d');
    var W = canvas.width, H = canvas.height;

    var game = {
      running: true,
      started: false,
      score: 0,
      lives: 3,
      player: { x: W / 2 - 15, y: H - 35, w: 30, h: 20, speed: 4 },
      bullets: [],
      invaders: [],
      invaderBullets: [],
      invaderDir: 1,
      invaderSpeed: 0.6,
      invaderDropTimer: 0,
      keys: {},
      shootCooldown: 0,
      gameOver: false
    };
    nermGame = game;

    // Create invader grid (5 rows x 8 cols of Nerms)
    function resetInvaders() {
      game.invaders = [];
      for (var row = 0; row < 4; row++) {
        for (var col = 0; col < 8; col++) {
          game.invaders.push({
            x: 30 + col * 42,
            y: 20 + row * 32,
            w: 28,
            h: 22,
            alive: true,
            frame: 0
          });
        }
      }
      game.invaderDir = 1;
      game.invaderSpeed = 0.6 + (game.score / 500) * 0.4;
    }
    resetInvaders();

    // Input
    function onKey(e) {
      if (!game.running) return;
      game.keys[e.key] = e.type === 'keydown';
      if (e.key === ' ' || e.key === 'ArrowLeft' || e.key === 'ArrowRight') e.preventDefault();
    }
    document.addEventListener('keydown', onKey);
    document.addEventListener('keyup', onKey);
    canvas.addEventListener('click', function () { game.started = true; });

    // Cleanup on close
    game._cleanup = function () {
      document.removeEventListener('keydown', onKey);
      document.removeEventListener('keyup', onKey);
    };

    // Draw Nerm face (simple pixel art)
    function drawNerm(x, y, w, h, frame) {
      // Body
      ctx.fillStyle = '#C0C0C0';
      ctx.fillRect(x, y, w, h);
      // Eyes
      ctx.fillStyle = '#000';
      var eyeOff = frame % 2 === 0 ? 0 : 1;
      ctx.fillRect(x + 6 + eyeOff, y + 5, 4, 5);
      ctx.fillRect(x + 18 - eyeOff, y + 5, 4, 5);
      // Pupils
      ctx.fillStyle = '#FF69B4';
      ctx.fillRect(x + 7 + eyeOff, y + 7, 2, 2);
      ctx.fillRect(x + 19 - eyeOff, y + 7, 2, 2);
      // Mouth
      ctx.fillStyle = '#FF69B4';
      ctx.fillRect(x + 10, y + 14, 8, 2);
      // Middle finger (tiny hand on the side)
      ctx.fillStyle = '#C0C0C0';
      ctx.fillRect(x + w, y + 4, 3, 8);
      ctx.fillRect(x + w, y + 2, 3, 3);
      // Ears
      ctx.fillStyle = '#C0C0C0';
      ctx.beginPath();
      ctx.moveTo(x + 2, y);
      ctx.lineTo(x - 2, y - 6);
      ctx.lineTo(x + 7, y);
      ctx.fill();
      ctx.beginPath();
      ctx.moveTo(x + w - 2, y);
      ctx.lineTo(x + w + 2, y - 6);
      ctx.lineTo(x + w - 7, y);
      ctx.fill();
    }

    // Draw player ship (skateboard)
    function drawPlayer() {
      var p = game.player;
      // Board
      ctx.fillStyle = '#FF69B4';
      ctx.fillRect(p.x, p.y + 10, p.w, 8);
      // Wheels
      ctx.fillStyle = '#FFD700';
      ctx.fillRect(p.x + 3, p.y + 18, 5, 4);
      ctx.fillRect(p.x + p.w - 8, p.y + 18, 5, 4);
      // Rider (triangle)
      ctx.fillStyle = '#00FFFF';
      ctx.beginPath();
      ctx.moveTo(p.x + p.w / 2, p.y);
      ctx.lineTo(p.x + 4, p.y + 10);
      ctx.lineTo(p.x + p.w - 4, p.y + 10);
      ctx.fill();
    }

    // Game loop
    var lastFrame = 0;
    var animFrame = 0;
    function loop(ts) {
      if (!game.running) { game._cleanup(); return; }
      requestAnimationFrame(loop);
      if (!game.started) {
        ctx.fillStyle = '#000';
        ctx.fillRect(0, 0, W, H);
        ctx.fillStyle = '#0f0';
        ctx.font = '16px "Comic Sans MS", cursive';
        ctx.textAlign = 'center';
        ctx.fillText('NERM INVADERS', W / 2, H / 2 - 40);
        ctx.font = '11px "Courier New", monospace';
        ctx.fillText('Click to Start', W / 2, H / 2);
        ctx.fillText('Defend Earth from Lord Nerm!!', W / 2, H / 2 + 20);
        drawNerm(W / 2 - 14, H / 2 - 90, 28, 22, 0);
        return;
      }
      if (game.gameOver) {
        ctx.fillStyle = '#000';
        ctx.fillRect(0, 0, W, H);
        ctx.fillStyle = '#FF0000';
        ctx.font = '20px "Comic Sans MS", cursive';
        ctx.textAlign = 'center';
        ctx.fillText('GAME OVER', W / 2, H / 2 - 20);
        ctx.fillStyle = '#FFD700';
        ctx.font = '14px "Comic Sans MS", cursive';
        ctx.fillText('Score: ' + game.score, W / 2, H / 2 + 10);
        ctx.fillStyle = '#0f0';
        ctx.font = '11px "Courier New", monospace';
        ctx.fillText('Click to play again', W / 2, H / 2 + 35);
        canvas.onclick = function () {
          game.score = 0; game.lives = 3; game.gameOver = false;
          game.bullets = []; game.invaderBullets = [];
          game.player.x = W / 2 - 15;
          resetInvaders();
          updateHUD();
          canvas.onclick = function () { game.started = true; };
        };
        return;
      }

      animFrame++;

      // Clear
      ctx.fillStyle = '#000';
      ctx.fillRect(0, 0, W, H);

      // Stars background
      ctx.fillStyle = '#333';
      for (var s = 0; s < 30; s++) {
        var sx = (s * 137 + animFrame * 0.2) % W;
        var sy = (s * 97 + animFrame * 0.1) % H;
        ctx.fillRect(sx, sy, 1, 1);
      }

      // Player input
      if (game.keys['ArrowLeft'] || game.keys['a']) game.player.x -= game.player.speed;
      if (game.keys['ArrowRight'] || game.keys['d']) game.player.x += game.player.speed;
      if (game.player.x < 0) game.player.x = 0;
      if (game.player.x > W - game.player.w) game.player.x = W - game.player.w;

      // Shoot
      if (game.shootCooldown > 0) game.shootCooldown--;
      if (game.keys[' '] && game.shootCooldown <= 0) {
        game.bullets.push({ x: game.player.x + game.player.w / 2 - 1, y: game.player.y - 4, w: 3, h: 8 });
        game.shootCooldown = 15;
      }

      // Move bullets
      for (var b = game.bullets.length - 1; b >= 0; b--) {
        game.bullets[b].y -= 5;
        if (game.bullets[b].y < -10) game.bullets.splice(b, 1);
      }

      // Move invader bullets
      for (var ib = game.invaderBullets.length - 1; ib >= 0; ib--) {
        game.invaderBullets[ib].y += 3;
        if (game.invaderBullets[ib].y > H + 10) game.invaderBullets.splice(ib, 1);
      }

      // Move invaders
      var hitEdge = false;
      var aliveCount = 0;
      for (var inv = 0; inv < game.invaders.length; inv++) {
        if (!game.invaders[inv].alive) continue;
        aliveCount++;
        game.invaders[inv].x += game.invaderSpeed * game.invaderDir;
        if (game.invaders[inv].x + game.invaders[inv].w > W - 5 || game.invaders[inv].x < 5) hitEdge = true;
      }
      if (hitEdge) {
        game.invaderDir *= -1;
        for (var inv2 = 0; inv2 < game.invaders.length; inv2++) {
          if (game.invaders[inv2].alive) game.invaders[inv2].y += 10;
        }
      }

      // Invaders shoot randomly
      if (aliveCount > 0 && Math.random() < 0.015) {
        var shooters = game.invaders.filter(function (inv) { return inv.alive; });
        var shooter = shooters[Math.floor(Math.random() * shooters.length)];
        game.invaderBullets.push({ x: shooter.x + shooter.w / 2, y: shooter.y + shooter.h, w: 3, h: 8 });
      }

      // Collision: bullets vs invaders
      for (var b2 = game.bullets.length - 1; b2 >= 0; b2--) {
        for (var inv3 = 0; inv3 < game.invaders.length; inv3++) {
          if (!game.invaders[inv3].alive) continue;
          if (rectsOverlap(game.bullets[b2], game.invaders[inv3])) {
            game.invaders[inv3].alive = false;
            game.bullets.splice(b2, 1);
            game.score += 10;
            updateHUD();
            break;
          }
        }
      }

      // Collision: invader bullets vs player
      for (var ib2 = game.invaderBullets.length - 1; ib2 >= 0; ib2--) {
        if (rectsOverlap(game.invaderBullets[ib2], game.player)) {
          game.invaderBullets.splice(ib2, 1);
          game.lives--;
          updateHUD();
          if (game.lives <= 0) { game.gameOver = true; }
        }
      }

      // Collision: invaders reach player
      for (var inv4 = 0; inv4 < game.invaders.length; inv4++) {
        if (game.invaders[inv4].alive && game.invaders[inv4].y + game.invaders[inv4].h >= game.player.y) {
          game.gameOver = true;
        }
      }

      // Check if all invaders dead — next wave
      if (aliveCount === 0) {
        resetInvaders();
      }

      // Draw invaders
      for (var inv5 = 0; inv5 < game.invaders.length; inv5++) {
        if (!game.invaders[inv5].alive) continue;
        var f = Math.floor(animFrame / 30) % 2;
        drawNerm(game.invaders[inv5].x, game.invaders[inv5].y, game.invaders[inv5].w, game.invaders[inv5].h, f);
      }

      // Draw player
      drawPlayer();

      // Draw bullets
      ctx.fillStyle = '#00FF00';
      for (var b3 = 0; b3 < game.bullets.length; b3++) {
        ctx.fillRect(game.bullets[b3].x, game.bullets[b3].y, game.bullets[b3].w, game.bullets[b3].h);
      }

      // Draw invader bullets
      ctx.fillStyle = '#FF0000';
      for (var ib3 = 0; ib3 < game.invaderBullets.length; ib3++) {
        ctx.fillRect(game.invaderBullets[ib3].x, game.invaderBullets[ib3].y, game.invaderBullets[ib3].w, game.invaderBullets[ib3].h);
      }
    }

    function rectsOverlap(a, b) {
      return a.x < b.x + b.w && a.x + a.w > b.x && a.y < b.y + b.h && a.y + a.h > b.y;
    }

    function updateHUD() {
      var scoreEl = document.getElementById('y2k-nerm-score');
      var livesEl = document.getElementById('y2k-nerm-lives');
      if (scoreEl) scoreEl.textContent = 'Score: ' + game.score;
      if (livesEl) livesEl.textContent = 'Lives: ' + game.lives;
    }

    requestAnimationFrame(loop);
  }

  /* ============================================================
     INJECT Y2K ELEMENTS
     ============================================================ */
  function injectY2KElements() {
    // Marquee
    if (!document.getElementById('y2k-marquee')) {
      var marquee = createEl('div', { id: 'y2k-marquee', class: 'y2k-marquee' },
        '<span>\u2605 Welcome 2 RIPNDIP \u2605 The Internets #1 source 4 Lord Nermal \u2605 Best viewed in Netscape Navigator 4.0 at 800x600 \u2605 Sign our guestbook!! \u2605 Visitor #42069 \u2605 Add us on AIM: xXx_RIPNDIP_xXx \u2605 Top 8 material \u2605 \u{1F495}tHaNkS 4 ViSiTiNg\u{1F495} \u2605</span>'
      );
      var mc = document.querySelector('.main-content');
      if (mc) mc.insertBefore(marquee, mc.firstChild);
    }

    // Under Construction
    if (!document.getElementById('y2k-construction')) {
      var construction = createEl('div', { id: 'y2k-construction', class: 'y2k-under-construction' },
        '\u{1F6A7} \u26A0\uFE0F UNDER CONSTRUCTION \u26A0\uFE0F \u{1F6A7} pArDoN oUr DuSt!! cOmE bAcK sOoN!!'
      );
      var mc2 = document.querySelector('.main-content');
      if (mc2) mc2.appendChild(construction);
    }

    // Music Player
    if (!document.getElementById('y2k-music-player')) {
      var player = createEl('div', { id: 'y2k-music-player', class: 'y2k-music-player' });
      player.innerHTML =
        '<div class="y2k-mp-title">\u266B RIPNDIP FM \u266B</div>' +
        '<div class="y2k-mp-track">\u{1F3B5} Smash Mouth - All Star \u{1F3B5}</div>' +
        '<div class="y2k-mp-bar"><div class="y2k-mp-progress"></div></div>' +
        '<div class="y2k-mp-controls">' +
          '<span class="y2k-mp-btn">\u23EE Prev</span>' +
          '<span class="y2k-mp-btn" id="y2k-play-btn">\u25B6 Play</span>' +
          '<span class="y2k-mp-btn">\u23ED Next</span>' +
        '</div>';
      var mc3 = document.querySelector('.main-content');
      if (mc3) mc3.insertBefore(player, mc3.children[1] || null);

      var tracks = [
        '\u{1F3B5} Smash Mouth - All Star \u{1F3B5}',
        '\u{1F3B5} Blink-182 - All The Small Things \u{1F3B5}',
        '\u{1F3B5} Lit - My Own Worst Enemy \u{1F3B5}',
        '\u{1F3B5} Third Eye Blind - Semi-Charmed Life \u{1F3B5}',
        '\u{1F3B5} Eve 6 - Inside Out \u{1F3B5}',
        '\u{1F3B5} Sugar Ray - Fly \u{1F3B5}',
        '\u{1F3B5} New Radicals - You Get What You Give \u{1F3B5}',
        '\u{1F3B5} Len - Steal My Sunshine \u{1F3B5}'
      ];
      var trackIdx = 0;
      setInterval(function () {
        var trackEl = player.querySelector('.y2k-mp-track');
        if (trackEl && document.body.classList.contains('y2k-mode')) {
          trackIdx = (trackIdx + 1) % tracks.length;
          trackEl.innerHTML = tracks[trackIdx];
        }
      }, 30000);
    }

    // Visitor Counter (always 42069)
    if (!document.getElementById('y2k-counter')) {
      var counter = createEl('div', { id: 'y2k-counter', class: 'y2k-visitor-counter' },
        '\u{1F4DF} Visitors: 0042069'
      );
      var footer = document.querySelector('.site-footer .page-width');
      if (footer) footer.appendChild(counter);
    }

    // Product Tour Ring (random product webring)
    if (!document.getElementById('y2k-webring')) {
      var webring = createEl('div', { id: 'y2k-webring', class: 'y2k-webring' });
      webring.innerHTML =
        '<b>\u{1F310} RIPNDIP Product Tour Ring \u{1F310}</b><br>' +
        '[ <a href="#" class="y2k-random-product">\u25C0 Prev</a> | ' +
        '<a href="#" class="y2k-random-product">Random</a> | ' +
        '<a href="#" class="y2k-random-product">Next \u25B6</a> ]<br>' +
        '<small>Hop around the product ring & discover something sick</small>';
      var footer2 = document.querySelector('.site-footer .page-width');
      if (footer2) footer2.appendChild(webring);

      // Bind all random product links
      var rpLinks = webring.querySelectorAll('.y2k-random-product');
      for (var r = 0; r < rpLinks.length; r++) {
        rpLinks[r].addEventListener('click', goToRandomProduct);
      }
    }

    // Guestbook
    if (!document.getElementById('y2k-guestbook')) {
      var gb = createEl('div', { id: 'y2k-guestbook', class: 'y2k-webring' });
      gb.innerHTML =
        '\u{1F4DD} <b>Sign Our Guestbook!!</b> \u{1F4DD}<br>' +
        '<span style="font-size:10px;color:#808080!important;">Last signed by: xXx_NermLuvr_xXx on 03/15/1999</span><br>' +
        '<span style="font-size:10px;color:#808080!important;">"OMG this site is SO cool!! Lord Nermal 4ever!! - Tiffany, age 14, California"</span>';
      var footer3 = document.querySelector('.site-footer .page-width');
      if (footer3) footer3.appendChild(gb);
    }

    // AIM Status
    if (!document.getElementById('y2k-aim-status')) {
      var aim = createEl('div', { id: 'y2k-aim-status', class: 'y2k-webring' });
      aim.innerHTML =
        '<div style="display:flex;align-items:center;justify-content:center;gap:6px;">' +
          '<span style="display:inline-block;width:8px;height:8px;background:#00FF00;border-radius:50%;box-shadow:0 0 4px #0f0;animation:y2k-blink 2s ease-in-out infinite;"></span>' +
          '<b style="font-size:12px;">xXx_RIPNDIP_xXx is Online</b>' +
        '</div>' +
        '<div style="font-size:10px;color:#808080!important;margin-top:4px;">' +
          'Away Message: "brb skateboarding w/ nerm \u{1F3C4}\u{1F408}"' +
        '</div>';
      var footer4 = document.querySelector('.site-footer .page-width');
      if (footer4) footer4.appendChild(aim);
    }

    // Taskbar
    if (!document.getElementById('y2k-taskbar')) {
      var taskbar = createEl('div', { id: 'y2k-taskbar', class: 'y2k-taskbar' });
      taskbar.innerHTML =
        '<div class="y2k-start-btn" id="y2k-start-btn">\u{1F5A5}\uFE0F Start</div>' +
        '<div class="y2k-taskbar-divider"></div>' +
        '<div class="y2k-taskbar-window">\u{1F310} RIPNDIP.exe</div>' +
        '<div class="y2k-taskbar-window">\u{1F3B5} RIPNDIP FM</div>' +
        '<div class="y2k-taskbar-clock" id="y2k-clock"></div>';
      document.body.appendChild(taskbar);

      document.getElementById('y2k-start-btn').addEventListener('click', function (e) {
        e.stopPropagation();
        toggleStartMenu();
      });
    }
  }

  /* ---- REMOVE Y2K ELEMENTS ---- */
  function removeY2KElements() {
    var ids = ['y2k-marquee', 'y2k-construction', 'y2k-counter', 'y2k-webring',
               'y2k-guestbook', 'y2k-aim-status', 'y2k-music-player', 'y2k-taskbar',
               'y2k-start-menu', 'y2k-nerm-dialog', 'y2k-vip-dialog'];
    for (var i = 0; i < ids.length; i++) {
      var el = document.getElementById(ids[i]);
      if (el) el.parentNode.removeChild(el);
    }
    var sparkleEls = document.querySelectorAll('.y2k-sparkle');
    for (var j = 0; j < sparkleEls.length; j++) {
      sparkleEls[j].parentNode.removeChild(sparkleEls[j]);
    }
    var fallingEls = document.querySelectorAll('.y2k-falling-star');
    for (var k = 0; k < fallingEls.length; k++) {
      fallingEls[k].parentNode.removeChild(fallingEls[k]);
    }
  }

  /* ---- SPARKLE CURSOR ---- */
  function startSparkles() {
    if (sparkleInterval) return;
    var lastX = 0, lastY = 0;
    function onMove(e) { lastX = e.clientX; lastY = e.clientY; }
    document.addEventListener('mousemove', onMove);
    sparkleInterval = setInterval(function () {
      if (!document.body.classList.contains('y2k-mode')) return;
      var spark = createEl('span', { class: 'y2k-sparkle' });
      spark.textContent = sparkles[Math.floor(Math.random() * sparkles.length)];
      var dx = (Math.random() - 0.5) * 60;
      var dy = -Math.random() * 40 - 10;
      spark.style.left = lastX + 'px';
      spark.style.top = lastY + 'px';
      spark.style.setProperty('--y2k-dx', dx + 'px');
      spark.style.setProperty('--y2k-dy', dy + 'px');
      document.body.appendChild(spark);
      setTimeout(function () { if (spark.parentNode) spark.parentNode.removeChild(spark); }, 800);
    }, 120);
    document._y2kMouseMove = onMove;
  }

  function stopSparkles() {
    if (sparkleInterval) { clearInterval(sparkleInterval); sparkleInterval = null; }
    if (document._y2kMouseMove) {
      document.removeEventListener('mousemove', document._y2kMouseMove);
      delete document._y2kMouseMove;
    }
  }

  /* ---- TASKBAR CLOCK ---- */
  function startClock() {
    if (clockInterval) return;
    updateClock();
    clockInterval = setInterval(updateClock, 1000);
  }

  function stopClock() {
    if (clockInterval) { clearInterval(clockInterval); clockInterval = null; }
  }

  function updateClock() {
    var clockEl = document.getElementById('y2k-clock');
    if (!clockEl) return;
    var now = new Date();
    var h = now.getHours();
    var ampm = h >= 12 ? 'PM' : 'AM';
    h = h % 12 || 12;
    var m = String(now.getMinutes()).padStart(2, '0');
    clockEl.textContent = h + ':' + m + ' ' + ampm;
  }

  /* ---- INIT ---- */
  function init() {
    var links = document.querySelectorAll('.y2k-toggle-link');
    for (var i = 0; i < links.length; i++) {
      links[i].addEventListener('click', toggleY2K);
    }
    if (isY2KActive()) { enableY2K(); } else { updateToggleLabels(false); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
